import {tabType} from "../../actions/tab/type";

const initialState = {
    isChangeTabView: false,
    tabKey: null,
    columns: null,
    dataSource: null,
}

const tabReducer = (state = initialState,
                    action) => {
    switch (action.type) {
        case tabType.CHANGE_CARD_VIEW:
            return {
                ...state,
                isChangeTabView: action.params ? action.params : !state.isChangeTabView
            }

        case tabType.POST_TAB_KEY:
            return {
                ...state,
                tabKey: action.key,
            }
        case tabType.POST_TAB_COLUMNS:
            return {
                ...state,
                columns: action.columns
            }
        case tabType.POST_TAB_DATA_SOURCE:
            return {
                ...state,
                dataSource: action.dataSource
            }

        default:
            return state
    }
}

export default tabReducer